var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-view-field',_vm._g(_vm._b({staticClass:"vertical",attrs:{"label":_vm.label}},'vg-view-field',_vm.$attrs,false),_vm.$listeners),[_c('vg-image-uploader',{attrs:{"disabled":"","file-list":_vm.imageFiles,"preview-full-image":false},on:{"click-preview":_vm.onPreview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }